import { Modal } from 'react-bootstrap'

export const SgOnlyModal = ({ show, setShowModal }) => {

	return (
		<>
			<Modal 
				show={show} 
				onHide={() => { setShowModal(false) }}
			>
				<Modal.Header closeButton>
					<Modal.Title>Information</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				Sorry, this job is open for locals only
				</Modal.Body>
			</Modal>
		</>
	)
}
